import PropTypes from 'prop-types';

function FakeErrorPage({ forceBreak = true }) {
  const urlParams = new URLSearchParams(window.location.search);
  const error = urlParams.get('error');

  if (forceBreak)
    throw new Error(error || 'Add a custom error message by adding "?error=Your error message here" to the URL');
  return <div>Should never render</div>;
}

FakeErrorPage.propTypes = {
  forceBreak: PropTypes.bool,
};

export default FakeErrorPage;
